<template>
  <user-dashboard
    :auto-refresh="true"
    :stat-bar-stats="statBarStats"
    :graph-stats="graphStats"
    :table-fields="tableFields"
    :table-stats="tableStats"
    :stat-bar-sub-stats="statBarSubStats">
  </user-dashboard>
</template>

<script>
    import UserDashboard from '@/components/UserDashboard'
    import {getBasePublisherField} from '@/reports/components/ReportUtils'

    export default {
        name: 'AdminDashboard',
        data() {
            return {
                statBarStats: ['bids', 'clears', 'clear_rate', 'avg_spend_cpm', 'spend', 'profit'],
                graphStats: ['bids', 'clears', 'spend', 'avg_spend_cpm', 'profit'],
                statBarSubStats: [],
                tableStats: [ 'bids', 'bid_rate', 'clears', 'clear_rate', 'cost', 'spend' ]
            }
        },
        computed: {
            mode() {
                return this.$route.path.split("/")[1]
            },
            tableFields() {
                return [getBasePublisherField(this.mode)]
            },
        },
        components: {
            UserDashboard
        }
    }
</script>



// WEBPACK FOOTER //
// src/admin/pages/Dashboard.vue